//Reset data
export const RESET = "CHAT_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "CHAT_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CHAT_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CHAT_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CHAT_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "CHAT_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CHAT_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CHAT_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CHAT_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CHAT_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "CHAT_CREATE_SET_CREATED"
export const SET_IS_CREATED = "CHAT_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "CHAT_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "CHAT_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CHAT_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CHAT_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CHAT_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "CHAT_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "CHAT_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CHAT_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CHAT_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CHAT_CREATE_SET_MODAL_TYPE"